import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "p-4 flex items-start gap-3" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-900 mb-1" }
const _hoisted_5 = { class: "text-sm text-gray-600" }
const _hoisted_6 = { class: "h-1 bg-gray-100" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-vue-next'

interface Props {
  type?: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
  duration?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationToast',
  props: {
    type: { default: 'info' },
    title: {},
    message: {},
    duration: { default: 5000 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const visible = ref(false)
const progress = ref(100)
let timer: number | null = null
let progressTimer: number | null = null

const typeClasses = computed(() => {
  const classes = {
    success: 'border-green-500',
    error: 'border-red-500',
    warning: 'border-orange-500',
    info: 'border-blue-500'
  }
  return classes[props.type]
})

const progressClass = computed(() => {
  const classes = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    warning: 'bg-orange-500',
    info: 'bg-blue-500'
  }
  return classes[props.type]
})

const close = () => {
  visible.value = false
  if (timer) clearTimeout(timer)
  if (progressTimer) clearInterval(progressTimer)
  setTimeout(() => emit('close'), 300)
}

onMounted(() => {
  visible.value = true
  
  // Progress bar
  const interval = 50
  const step = (interval / props.duration) * 100
  progressTimer = window.setInterval(() => {
    progress.value -= step
    if (progress.value <= 0) {
      progress.value = 0
      if (progressTimer) clearInterval(progressTimer)
    }
  }, interval)
  
  // Auto close
  timer = window.setTimeout(close, props.duration)
})

onUnmounted(() => {
  if (timer) clearTimeout(timer)
  if (progressTimer) clearInterval(progressTimer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
          'fixed top-4 right-4 z-50 max-w-md w-full bg-white rounded-xl shadow-2xl border-l-4 overflow-hidden',
          typeClasses.value
        ])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.type === 'success')
                    ? (_openBlock(), _createBlock(_unref(CheckCircle), {
                        key: 0,
                        class: "w-6 h-6 text-green-600"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'error')
                    ? (_openBlock(), _createBlock(_unref(XCircle), {
                        key: 1,
                        class: "w-6 h-6 text-red-600"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'warning')
                    ? (_openBlock(), _createBlock(_unref(AlertCircle), {
                        key: 2,
                        class: "w-6 h-6 text-orange-600"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'info')
                    ? (_openBlock(), _createBlock(_unref(Info), {
                        key: 3,
                        class: "w-6 h-6 text-blue-600"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1)
                ]),
                _createElementVNode("button", {
                  onClick: close,
                  class: "flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                }, [
                  _createVNode(_unref(X), { class: "w-5 h-5" })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-full transition-all duration-100 ease-linear", progressClass.value]),
                  style: _normalizeStyle({ width: progress.value + '%' })
                }, null, 6)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})